<template>
  <CategoriesList
    :categories="categories"
    title="Наши товары:"
    :initial-category-id="initialCategoryId"
  >
    <template #products="{ category }">
      <MainPageCategoryProductsList :category="category" />
    </template>
  </CategoriesList>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import CategoriesList from '@/components/CategoriesList/CategoriesList.vue';
  import MainPageCategoryProductsList from './MainPageCategoryProductsList.vue';
  import { useRoute } from 'vue-router';
  import { Category, getCategoriesList } from '@/services/category/api';

  const categories = ref<Category[] | null>(null);

  const route = useRoute();

  const initialCategoryId = route.query.category ? Number(route.query.category) : null;

  getCategoriesList().then(response => {
    categories.value = response.data.data;
  });
</script>
